// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwBalloonPopupPanel from 'viewmodel/AwBalloonPopupPanelViewModel';
import AwList from 'viewmodel/AwListViewModel';
import SearchHistoryCell from 'viewmodel/SearchHistoryCellViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "reveal": {
      "actionType": "dataProvider",
      "method": "performHistorySearch"
    },
    "loadData": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query GetSearchHistory($collaborationspaceId: String) { getSearchHistory(collaborationspaceId: $collaborationspaceId) }",
            "variables": {
              "collaborationspaceId": "test"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.search.accsessionid}}"
      },
      "outputData": {
        "searchHistory": "data.data.getSearchHistory.items",
        "totalCount": "data.data.getSearchHistory.totalCount"
      },
      "deps": "js/desSearchService"
    },
    "performSearch": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "des-search.query",
          "eventData": {
            "query": "{{parameters.eventData.cellHeader1}}",
            "category": "{{parameters.eventData.category}}",
            "categoryUi": "{{parameters.eventData.categoryUi}}"
          }
        }]
      }
    }
  },
  "data": {},
  "dataProviders": {
    "performHistorySearch": {
      "action": "loadData",
      "response": "{{data.searchHistory}}",
      "totalFound": "{{data.totalCount}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "lifecycleHooks": {
    "onMount": "reveal"
  },
  "onEvent": [{
    "eventId": "performHistorySearch.selectionChangeEvent",
    "action": "performSearch",
    "inputArgs": {
      "eventData": "{{eventData.selectedObjects[0]}}"
    }
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    }
  },
  "_viewModelId": "SearchHistory",
  "_uniqueViewModelId": "SearchHistory",
  "ctx": {
    "search": {
      "type": "object"
    }
  }
};

/*
<aw-balloon-popup-panel>
    <aw-list dataprovider="dataProviders.performHistorySearch">
        <search-history-cell vmo="item" ></search-history-cell>
    </aw-list>
</aw-balloon-popup-panel>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwBalloonPopupPanel, null, /*#__PURE__*/React.createElement(AwList, {
    dataprovider: dataProviders.performHistorySearch,
    showDropArea: null,
    dndHandler: props.viewModel.dndHandler
  }, ({
    item,
    index
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "            ", /*#__PURE__*/React.createElement(SearchHistoryCell, {
      vmo: AwParseService.instance("item")({
        props,
        data,
        fields,
        dataProviders,
        ctx,
        i18n,
        actions,
        subPanelContext,
        viewPath,
        conditions,
        formProp,
        dispatch,
        selectionModels,
        editHandlers,
        chartProviders,
        ports,
        item,
        index
      })
    }));
  }));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;